// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"00d3e2bd","190":"aeb40a9a","231":"9a0948c8","236":"539c2255","293":"24519e3d","362":"d6a26698","421":"690b8c69","453":"7f736490","486":"41cdf834","647":"cdf3c37d","683":"c3cf57db","722":"a2f250a0","738":"ec025bdb"}[chunkId] + ".chunk.js";
};